import {
  GET_COLLECTION_FUNCTION_GROUP_LIST_FULFILLED,
  CollectionFunctionGroupActionTypes,
  CollectionFunctionGroupState,
  GET_COLLECTION_FUNCTION_GROUP_LIST,
  GET_COLLECTION_FUNCTION_GROUP_PENDING,
  GET_COLLECTION_FUNCTION_GROUP_FULFILLED,
  DELETE_COLLECTION_FUNCTION_GROUP_FULFILLED,
  SELECT_COLLECTION_FUNCTION_GROUP,
  OPEN_COLLECTION_FUNCTION_GROUP_CREATE_PAGE,
  CLOSE_COLLECTION_FUNCTION_GROUP_CREATE_PAGE,
  OPEN_COLLECTION_FUNCTION_GROUP_EDIT_PAGE,
  CLOSE_COLLECTION_FUNCTION_GROUP_EDIT_PAGE,
  CREATE_COLLECTION_FUNCTION_GROUP_FULFILLED,
  SET_COLLECTION_FUNCTION_GROUP_LOADING,
  CREATE_COLLECTION_FUNCTION_GROUP_PENDING,
} from './collectionFunctionGroup.types';

export const initialState: CollectionFunctionGroupState = {
  entities: [],
  single: null,
  selected: [],
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isEditPopupOpen: false,
    isLoading: false,
  },
};

export default function collectionFunctionGroupReducer(
  state = initialState,
  action: CollectionFunctionGroupActionTypes,
): CollectionFunctionGroupState {
  switch (action.type) {
    case GET_COLLECTION_FUNCTION_GROUP_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_COLLECTION_FUNCTION_GROUP_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_COLLECTION_FUNCTION_GROUP_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_COLLECTION_FUNCTION_GROUP_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_COLLECTION_FUNCTION_GROUP:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_COLLECTION_FUNCTION_GROUP_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_COLLECTION_FUNCTION_GROUP_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_COLLECTION_FUNCTION_GROUP_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case OPEN_COLLECTION_FUNCTION_GROUP_CREATE_PAGE:
      return {
        ...state,
        single: null,
        createdId: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: true,
        },
      };

    case CLOSE_COLLECTION_FUNCTION_GROUP_CREATE_PAGE:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: false,
        },
      };

    case OPEN_COLLECTION_FUNCTION_GROUP_EDIT_PAGE:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isEditPopupOpen: true,
        },
      };

    case CLOSE_COLLECTION_FUNCTION_GROUP_EDIT_PAGE:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isEditPopupOpen: false,
        },
      };

    case SET_COLLECTION_FUNCTION_GROUP_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
